const DEFAULT_MESSAGE = 'Sorry, we\'re experiencing a problem and are unable to load this information. Please try again later.';
import cx from 'classnames';

const ServiceError = ( {message, className} ) =>
    <div className={cx( 'text-center', className )}>
        <h2 className="my-4 text-lg leading-tight">
            {message || DEFAULT_MESSAGE}
        </h2>
        <p className="mb-4 text-grey-dark">
            Please contact our Customer Support team to complete this order by calling
            {' '}
            <b className="text-grey-darker whitespace-no-wrap">{upi.conf.phoneTollFree}</b>
        </p>
    </div>;

export default ServiceError;
